import { createRoot } from 'react-dom/client'
import App from './App'
import './utils/tracking'
import './utils/monacoLoaderConfig'
import './utils/apms'

const root = createRoot(document.getElementById('root')!)
root.render(<App />)
